import { Provider } from '@angular/core';
import { AbstractRejectAnalysisService } from './fednow/service/abstraction/abstract.reject-analysis.service';
import { MockRejectAnalysisService } from './fednow/service/mock/mock.reject-analysis.service';
import { RejectAnalysisService } from './fednow/service/http/reject-analysis.service';
import { AbstractInstitutionService } from './fednow/service/abstraction/abstract.institution.service';
import { environment } from 'src/environments/environment';
import { MockInstitutionService } from './fednow/service/mock/mock.institution.service';
import { InstitutionService } from './fednow/service/http/institution.service';
import { CycleDateService } from './fednow/service/http/cycle-date.service';
import { AbstractCycleDateService } from './fednow/service/abstraction/abstract.cycle-date.service';
import { MockCycleDateService } from './fednow/service/mock/mock.cycle-date.service';
import { AbstractAccountActivityCorrespondentService } from './fednow/service/abstraction/abstract.account-activity-correspondent.service';
import { AccountActivityCorrespondentService } from './fednow/service/http/account-activity-correspondent.service';
import { AbstractAccountActivityRespondentService } from './fednow/service/abstraction/abstract.account-activity-respondent.service';
import { AccountActivityRespondentService } from './fednow/service/http/account-activity-respondent.service';
import { AbstractAccountService } from './fednow/service/abstraction/abstract.account.service';
import { AccountService } from './fednow/service/http/account.service';
import { AbstractMasterAccountService } from './fednow/service/abstraction/abstract.master-account.service';
import { MasterAccountService } from './fednow/service/http/master-account.service';
import { AbstractRespondentService } from './fednow/service/abstraction/abstract.respondent.service';
import { RespondentService } from './fednow/service/http/respondent.service';
import { AbstractReturnInitiateService } from './fednow/service/abstraction/abstract.return-initiated.service';
import { ReturnInitiateService } from './fednow/service/http/return-initiated.service';
import { AbstractReturnPaymentService } from './fednow/service/abstraction/abstract.return-payment.service';
import { ReturnPaymentService } from './fednow/service/http/return-payment.service';
import { AbstractReturnListService } from './fednow/service/abstraction/abstract.return-list.service';
import { ReturnListService } from './fednow/service/http/return-list.service';
import { AbstractSendPaymentService } from './fednow/service/abstraction/abstract.send-payment.service';
import { SendPaymentService } from './fednow/service/http/send-payment.service';
import { AbstractSessionService } from './fednow/service/abstraction/abstract.session.service';
import { SessionService } from './fednow/service/http/session.service';
import { AbstractSettlementService } from './fednow/service/abstraction/abstract.settlement.service';
import { SettlementService } from './fednow/service/http/settlement.service';
import { AbstractTransactionService } from './fednow/service/abstraction/abstract.transaction.service';
import { TransactionService } from './fednow/service/http/transaction.service';
import { MockAccountActivityRespondentService } from './fednow/service/mock/mock.account-activity-respondent.service';
import { MockTransactionService } from './fednow/service/mock/mock.transaction.service';
import { MockReturnListService } from './fednow/service/mock/mock.return-list.service';
import { MockReturnInitiateService } from './fednow/service/mock/mock.return-initiated.service';
import { MockReturnPaymentService } from './fednow/service/mock/mock.return-payment.service';
import { AbstractNotificationService } from './fednow/service/abstraction/abstract.notification.service';
import { NotificationService } from './fednow/service/http/notification.service';
import { MockNotificationService } from './fednow/service/mock/mock.notification.service';
import { MockRespondentService } from './fednow/service/mock/mock.respondent.service';
import { MockAccountService } from './fednow/service/mock/mock.account.service';
import { MockSendPaymentService } from './fednow/service/mock/mock.send-payment.service';
import { MockSessionService } from './fednow/service/mock/mock.session.service';
import { MockSettlementService } from './fednow/service/mock/mock.settlement.service';
import { MockMasterAccountService } from './fednow/service/mock/mock.master-account.service';
import { MockAccountActivityCorrespondentService } from './fednow/service/mock/mock.account-activity-correspondent.service';
import { RFPReceiveService } from './fednow/service/http/rfp-receive.service';
import { MockRFPReceiveService } from './fednow/service/mock/mock.rfp-receive.service';
import { AbstractRFPReceiveService } from './fednow/service/abstraction/abstract.rfp-receive.service';
import { AbstractRFPSendService } from './fednow/service/abstraction/abstract.rfp-send.service';
import { RFPSendService } from './fednow/service/http/rfp-send.service';
import { MockRFPSendService } from './fednow/service/mock/mock.rfp-send.service';
import { AbstractRFPSendZeroDollarService } from './fednow/service/abstraction/abstract.rfp-send-zero-dollar.service';
import { RFPZeroDollarSendService } from './fednow/service/http/rfp-send-zero-dollar.service';
import { MockRFPZeroDollarSendService } from './fednow/service/mock/mock.rfp-send-zero-dollar.service';
import { AbstractGeneralService } from './fednow/service/abstraction/abstract.general.service';
import { MockGeneralService } from './fednow/service/mock/mock.general.service';
import { GeneralService } from './fednow/service/http/general.service';
import { AbstractConfigurationService } from './fednow/service/abstraction/abstract.configuration.service';
import { ConfigurationService } from './fednow/service/http/configuration.service';
import { AbstractConfigurationPendingChangesService } from './fednow/service/abstraction/abstract.configuration-pending-changes.service';
import { MockConfigurationPendingChangesService } from './fednow/service/mock/mock.configuration-pending-changes.service';
import { ConfigurationPendingChangesService } from './fednow/service/http/configuration-pending-changes.service';
import { AbstractConfigurationReviewStatusService } from './fednow/service/abstraction/abstract.configuration-review-status.service';
import { MockConfigurationReviewStatusService } from './fednow/service/mock/mock.configuration-review-status.service';
import { ConfigurationReviewStatusService } from './fednow/service/http/configuration-review-status.service';
import { MockConfigurationService } from './fednow/service/mock/mock.configuration.service';
import { AbstractAuditReviewService } from './fednow/service/abstraction/abstract.audit-review.service';
import { MockAuditReviewService } from './fednow/service/mock/mock.audit-review.service';
import { AuditReviewService } from './fednow/service/http/audit-review.service';
import { AbstractRtpAccountActivityCorrespondentService } from './rtp/service/abstraction/abstract.account-activity-correspondent.service';
import { AbstractRtpAccountActivityRespondentService } from './rtp/service/abstraction/abstract.account-activity-respondent.service';
import { AccountRtpActivityRespondentService } from './rtp/service/http/account-activity-respondent.service';
import { AccountRtpActivityCorrespondentService } from './rtp/service/http/account-activity-correspondent.service';
import { AbstractRtpSettlementService } from './rtp/service/abstraction/abstract.rtp-settlement.service';
import { MockRtpSettlementService } from './rtp/service/mock/mock.settlement.service';
import { RtpSettlementService } from './rtp/service/http/rtp-settlement.service';
import { AbstractCycleDateWindowService } from './rtp/service/abstraction/abstract.cycle-date-window.service';
import { MockRtpCycleDateService } from './rtp/service/mock/mock.cycle-date-window.service';
import { RtpCycleDateService } from './rtp/service/http/cycle-date-window.service';
import { MockRtpAccountActivityCorrespondentService } from './rtp/service/mock/mock.account-activity-correspondent.service';
import { AbstractLmtActivityService } from './rtp/service/abstraction/abstract.lmt-activity.service';
import { MockLmtActivityService } from './rtp/service/mock/mock.lmt-activity.service';
import { LmtActivityService } from './rtp/service/http/lmt-activity.service';
import { AbstractFundingDetailsService } from './rtp/service/abstraction/abstract.funding-details.service';
import { FundingDetailsService } from './rtp/service/http/funding-details.service';
import { MockFundingDetailsService } from './rtp/service/mock/mock.funding-details.service';
import { MockRtpAccountActivityRespondentService } from './rtp/service/mock/mock.account-activity-respondent.service';
import { AbstractRtpCorrespondentReconService } from './rtp/service/abstraction/abstract.correspondent-reconcilation.service';
import { RtpCorrespondentReconService } from './rtp/service/http/correspondent-reconciliation.service';
import { MockRtpCorrespondentReconService } from './rtp/service/mock/mock.correspondent-reconciliation.service';
import { AbstractRtpRespondentReconService } from './rtp/service/abstraction/abstract.respondent-reconcilation.service';
import { MockRtpRespondentReconService } from './rtp/service/mock/mock.respondent-reconciliation.service';
import { RtpRespondentReconService } from './rtp/service/http/respondent-reconciliation.service';
import { AbstractAutoDisbursementService } from './rtp/service/abstraction/abstract.auto-disbursement.service';
import { MockAutoDisbursementService } from './rtp/service/mock/mock.auto-disbursement.service';
import { AutoDisbursementService } from './rtp/service/http/auto-disbursement.service';
import { AbstractDashboardDetailsService } from './dashboard/service/abstraction/abstract.dashboard-details.service';
import { DashboardDetailsService } from './dashboard/service/http/dashboard-details.service';
import { MockDashboardDetailsService } from './dashboard/service/mock/mock.dashboard-details.service';
import { AbstractRtpTransactionService } from './rtp/service/abstraction/abstract.rtp-transaction.service';
import { RtpTransactionService } from './rtp/service/http/rtp-transaction.service';
import { MockRtpTransactionService } from './rtp/service/mock/mock.rtp-transaction.service';
import { AbstractRtpReturnListService } from './rtp/service/abstraction/abstract.return-request-list.service';
import { MockReturnRequestListService } from './rtp/service/mock/mock.return-request-list.service';
import { ReturnRequestListService } from './rtp/service/http/return-request-list.service';
import { AbstractTransactionDualApprovalService } from './fednow/service/abstraction/abstract.transaction-dual-approval.service';
import { TransactionDualApprovalService } from './fednow/service/http/transaction-dual-approval.service';
import { MockTransactionDualApprovalService } from './fednow/service/mock/mock.transaction-dual-approval.service';
import { AbstractRtpSendPaymentService } from './rtp/service/abstraction/abstract.rtp-send-payment.service';
import { MockRtpSendPaymentService } from './rtp/service/mock/mock.rtp-send-payment.service';
import { RtpSendPaymentService } from './rtp/service/http/rtp-send-payment.service';
import { AbstractRtpConfigurationService } from './rtp/service/abstraction/abstract.rtp-configuration.service';
import { RtpConfigurationService } from './rtp/service/http/rtp-configuration.service';
import { MockRtpConfigurationService } from './rtp/service/mock/mock.rtp-configuration.service';
import { AbstractCombinedConfigurationService } from './rtp/service/abstraction/abstract.combined-configuration.service';
import { CombinedConfigurationService } from './rtp/service/http/combined-configuration.service';
import { MockCombinedConfigurationService } from './rtp/service/mock/mock.combined-configuration.service';
import { AbstractRtpReturnInitiatedService } from './rtp/service/abstraction/abstract.rtp-return-initiated.service';
import { RtpReturnInitiatedService } from './rtp/service/http/rtp-return-initiated.service';
import { MockRtpReturnInitiatedService } from './rtp/service/mock/mock.rtp-return-initiated.service';
import { AbstractRtpCorrespondentConfigurationService } from './rtp/service/abstraction/abstract.rtp-correspondent-configuration.service';
import { RtpCorrespondentConfigurationService } from './rtp/service/http/rtp-correspondent-configuration.service';
import { MockRtpCorrespondentConfigurationService } from './rtp/service/mock/mock.rtp-correspondent-configuration.service';
import { RtpTransactionDualApprovalService } from './rtp/service/http/rtp-transaction-dual-approval.service';
import { MockRtpTransactionDualApprovalService } from './rtp/service/mock/mock.rtp-transaction-dual-approval.service';

export const serviceProviders: Provider[] = [
  {
    provide: AbstractAccountActivityCorrespondentService,
    useClass: environment.useMock
      ? MockAccountActivityCorrespondentService
      : AccountActivityCorrespondentService,
  },
  {
    provide: AbstractAccountActivityRespondentService,
    useClass: environment.useMock
      ? MockAccountActivityRespondentService
      : AccountActivityRespondentService,
  },
  {
    provide: AbstractAccountService,
    useClass: environment.useMock ? MockAccountService : AccountService,
  },
  {
    provide: AbstractCycleDateService,
    useClass: environment.useMock ? MockCycleDateService : CycleDateService,
  },
  {
    provide: AbstractInstitutionService,
    useClass: environment.useMock ? MockInstitutionService : InstitutionService,
  },
  {
    provide: AbstractMasterAccountService,
    useClass: environment.useMock ? MockMasterAccountService : MasterAccountService,
  },
  {
    provide: AbstractRespondentService,
    useClass: environment.useMock ? MockRespondentService : RespondentService,
  },
  {
    provide: AbstractReturnInitiateService,
    useClass: environment.useMock ? MockReturnInitiateService : ReturnInitiateService,
  },
  {
    provide: AbstractReturnPaymentService,
    useClass: environment.useMock ? MockReturnPaymentService : ReturnPaymentService,
  },
  {
    provide: AbstractReturnListService,
    useClass: environment.useMock ? MockReturnListService : ReturnListService,
  },
  {
    provide: AbstractSendPaymentService,
    useClass: environment.useMock ? MockSendPaymentService : SendPaymentService,
  },
  {
    provide: AbstractSessionService,
    useClass: environment.useMock ? MockSessionService : SessionService,
  },
  {
    provide: AbstractSettlementService,
    useClass: environment.useMock ? MockSettlementService : SettlementService,
  },
  {
    provide: AbstractTransactionService,
    useClass: environment.useMock ? MockTransactionService : TransactionService,
  },
  {
    provide: AbstractNotificationService,
    useClass: environment.useMock ? MockNotificationService : NotificationService,
  },
  {
    provide: AbstractRFPReceiveService,
    useClass: environment.useMock ? MockRFPReceiveService : RFPReceiveService,
  },
  {
    provide: AbstractRFPSendService,
    useClass: environment.useMock ? MockRFPSendService : RFPSendService,
  },
  {
    provide: AbstractRFPSendZeroDollarService,
    useClass: environment.useMock ? MockRFPZeroDollarSendService : RFPZeroDollarSendService,
  },
  {
    provide: AbstractGeneralService,
    useClass: environment.useMock ? MockGeneralService : GeneralService,
  },
  {
    provide: AbstractConfigurationService,
    useClass: environment.useMock ? MockConfigurationService : ConfigurationService,
  },
  {
    provide: AbstractConfigurationPendingChangesService,
    useClass: environment.useMock
      ? MockConfigurationPendingChangesService
      : ConfigurationPendingChangesService,
  },
  {
    provide: AbstractConfigurationReviewStatusService,
    useClass: environment.useMock
      ? MockConfigurationReviewStatusService
      : ConfigurationReviewStatusService,
  },
  {
    provide: AbstractAuditReviewService,
    useClass: environment.useMock ? MockAuditReviewService : AuditReviewService,
  },
  {
    provide: AbstractRtpAccountActivityCorrespondentService,
    useClass: environment.useMock
      ? MockRtpAccountActivityCorrespondentService
      : AccountRtpActivityCorrespondentService,
  },
  {
    provide: AbstractRtpAccountActivityRespondentService,
    useClass: environment.useMock
      ? MockRtpAccountActivityRespondentService
      : AccountRtpActivityRespondentService,
  },
  {
    provide: AbstractRtpAccountActivityRespondentService,
    useClass: environment.useMock
      ? MockRtpAccountActivityRespondentService
      : AccountRtpActivityRespondentService,
  },
  {
    provide: AbstractRtpSettlementService,
    useClass: environment.useMock ? MockRtpSettlementService : RtpSettlementService,
  },
  {
    provide: AbstractCycleDateWindowService,
    useClass: environment.useMock ? MockRtpCycleDateService : RtpCycleDateService,
  },
  {
    provide: AbstractLmtActivityService,
    useClass: environment.useMock ? MockLmtActivityService : LmtActivityService,
  },
  {
    provide: AbstractFundingDetailsService,
    useClass: environment.useMock ? MockFundingDetailsService : FundingDetailsService,
  },
  {
    provide: AbstractRtpCorrespondentReconService,
    useClass: environment.useMock ? MockRtpCorrespondentReconService : RtpCorrespondentReconService,
  },
  {
    provide: AbstractRtpRespondentReconService,
    useClass: environment.useMock ? MockRtpRespondentReconService : RtpRespondentReconService,
  },
  {
    provide: AbstractAutoDisbursementService,
    useClass: environment.useMock ? MockAutoDisbursementService : AutoDisbursementService,
  },
  {
    provide: AbstractDashboardDetailsService,
    useClass: environment.useMock ? MockDashboardDetailsService : DashboardDetailsService,
  },
  {
    provide: AbstractRtpTransactionService,
    useClass: environment.useMock ? MockRtpTransactionService : RtpTransactionService,
  },
  {
    provide: AbstractRtpReturnListService,
    useClass: environment.useMock ? MockReturnRequestListService : ReturnRequestListService,
  },
  {
    provide: AbstractTransactionDualApprovalService,
    useClass: environment.useMock
      ? MockTransactionDualApprovalService
      : TransactionDualApprovalService,
  },
  {
    provide: RtpTransactionDualApprovalService,
    useClass: environment.useMock
      ? MockRtpTransactionDualApprovalService
      : RtpTransactionDualApprovalService,
  },
  {
    provide: AbstractRtpSendPaymentService,
    useClass: environment.useMock ? MockRtpSendPaymentService : RtpSendPaymentService,
  },
  {
    provide: AbstractRtpConfigurationService,
    useClass: environment.useMock ? MockRtpConfigurationService : RtpConfigurationService,
  },
  {
    provide: AbstractCombinedConfigurationService,
    useClass: environment.useMock ? MockCombinedConfigurationService : CombinedConfigurationService,
  },
  {
    provide: AbstractRtpReturnInitiatedService,
    useClass: environment.useMock ? MockRtpReturnInitiatedService : RtpReturnInitiatedService,
  },
  {
    provide: AbstractRtpCorrespondentConfigurationService,
    useClass: environment.useMock
      ? MockRtpCorrespondentConfigurationService
      : RtpCorrespondentConfigurationService,
  },
  {
    provide: AbstractRejectAnalysisService,
    useClass: environment.useMock ? MockRejectAnalysisService : RejectAnalysisService,
  },
];
